export default {
  'common.operation': 'Operation',
  'product.management.title': 'Product Management',
  'product.management.add': 'Add Product',
  'product.management.edit': 'Edit Product',
  'product.management.delete': 'Delete',
  'product.management.search': 'Search',
  'product.management.reset': 'Reset',
  'product.management.name': 'Product Name',
  'product.management.type': 'Product Type',
  'product.management.status': 'Status',
  'product.management.currency': 'Currency',
  'product.management.value': 'Product Value',
  'product.management.amount': 'Product Quantity',
  'product.management.price': 'Product Points',
  'product.management.quantity': 'Product Quantity',
  'product.management.limit': 'Purchase Limit',
  'product.management.dailyLimit': 'Daily Purchase Limit',
  'product.management.vipLimit': 'Purchase Limit',
  'product.management.vipLimitDisplay': 'VIP {{value}}',
  'product.management.vipPurchaseLimit': 'VIP Purchase Limit',
  'product.management.vipPurchaseLimitCount': 'Purchase Limit Count',
  'product.management.vipPurchaseLimitEnabled': 'Is Enabled',
  'product.management.vipLevel': 'VIP',
  'product.management.vipLimitZeroError': 'Enabled VIP level purchase limit cannot be 0',
  'product.management.sort': 'Sort',
  'product.management.flow': 'Product Flow',
  'product.management.cash': 'Cash',
  'product.management.props': 'Props',
  'product.management.propsCategory': 'Props Category',
  'product.management.propsCategory.luckySpin': 'Lucky Spin Ticket',
  'product.management.propsCategory.fuel': 'Fuel',
  'product.management.propsCategory.treasureBoxKey': 'Treasure Box Key',
  'product.management.keyType': 'Key Type',
  'product.management.keyType.WOOD': 'Wooden Key',
  'product.management.keyType.IRON': 'Iron Key',
  'product.management.keyType.BRONZE': 'Bronze Key',
  'product.management.keyType.SILVER': 'Silver Key',
  'product.management.keyType.GOLD': 'Gold Key',
  'product.management.keyType.DIAMOND': 'Diamond Key',
  'product.management.physical': 'Physical',
  'product.management.enable': 'Enable',
  'product.management.disable': 'Disable',
  'product.management.success': 'Success',
  'product.management.fail': 'Failed',
  'product.management.confirmDelete': 'Are you sure you want to delete?',
  'product.management.confirmEnable': 'Are you sure you want to enable?',
  'product.management.confirmDisable': 'Are you sure you want to disable?',
  'product.management.operator': 'Operator',
  'product.management.operateTime': 'Operate Time',
  'product.management.unknown': 'Unknown',
  'product.management.unknownStatus': 'Unknown Status',
  'product.language.title': 'Language Management',
  'product.language.add': 'Add Language',
  'product.language.edit': 'Edit Language',
  'product.language.delete': 'Delete',
  'product.language.language': 'Language',
  'product.language.image': 'Product Image',
  'product.language.success': 'Success',
  'product.language.fail': 'Failed',
  'product.language.confirmDelete': 'Are you sure you want to delete?',
  'product.language.operator': 'Operator',
  'product.language.operateTime': 'Operate Time',
  'product.stock.title': 'Stock Management',
  'product.stock.add': 'Add Stock',
  'product.stock.edit': 'Edit Stock',
  'product.stock.viewHistory': 'View History',
  'product.stock.available': 'Available Stock',
  'product.stock.freeze': 'Frozen Stock',
  'product.stock.total': 'Total Stock',
  'product.stock.changeType': 'Change Type',
  'product.stock.changeAmount': 'Change Amount',
  'product.stock.remark': 'Remark',
  'product.stock.history': 'Change History',
  'product.stock.increase': 'Increase',
  'product.stock.decrease': 'Decrease',
  'product.stock.success': 'Success',
  'product.stock.fail': 'Failed',
  'product.stock.recordNotFound': 'Record not found',
  'product.stock.operator': 'Operator',
  'product.stock.operateTime': 'Operate Time',
  'product.trade.title': 'Trade Records',
  'product.trade.orderId': 'Exchange ID',
  'product.trade.memberAccount': 'Member Account',
  'product.trade.type': 'Product Type',
  'product.trade.name': 'Product Name',
  'product.trade.currency': 'Currency',
  'product.trade.value': 'Product Value',
  'product.trade.price': 'Product Points',
  'product.trade.quantity': 'Exchange Quantity',
  'product.trade.time': 'Exchange Time',
  'product.trade.vipLevel': 'VIP Level',
  'product.trade.success': 'Success',
  'product.trade.fail': 'Failed',
  'product.trade.export': 'Export',
  'product.trade.exportWarning': 'Please select time range',
  'product.trade.exportLoading': 'Exporting data...',
  'product.trade.exportSuccess': 'Export successful',
  'product.trade.exportFail': 'Export failed'
};
